import { REPORTS_API } from "redux/api";

const LIVE_DISCOUNT_ENDPOINT = `/sales/live/discounts?`;

const LIVE_OPEN_SALES_ENDPOINT = `/sales/live/open-sales?`;

const LIVE_ORDERS_ENDPOINT = `/sales/live/tables?`;

const LIVE_REFUNDS_ENDPOINT = `/sales/live/refunds?`;

const LIVE_NET_SALES_ENDPOINT = `/sales/live/net-sales?`;

const LIVE_ORDER_NON_DINE_IN_ENDPOINT = `/sales/live/tracking?`;

const OVERALL_ORDER_NON_DINE_IN_ENDPOINT = `/sales/live/overall-tables?`;

const TRACKER_ENDPOINT = `/sales/live/overall-tracking?`;

const EMPLOYEE_STAFF_TIP_GRATUITY_ENDPOINT = `/sales/employee/staffTipAndGratuity?`;

const EMPLOYEE_STAFF_DISCOUNT_ENDPOINT = `/sales/employee/staffDiscount?`;

const EMPLOYEE_STAFF_PERFORMANCE_ENDPOINT = `/sales/employee/staffPerformance?`;

const EMPLOYEE_STAFF_ACTIVITY_ENDPOINT = `/sales/employee/staffActivity?`;



const generateQueryParams = (payload) => {
    let query = "";
    if(payload?.locationId){
        query+="&locationId="+payload?.locationId
    }else if(payload?.locationid){
        query+="&locationId="+payload?.locationid
    }

    if(payload?.startDate){
        query+="&startDate="+payload?.startDate
    }
    if(payload?.endDate){
        query+="&endDate="+payload?.endDate
    }

    if(payload?.tablePageNo){
        query+="&page="+payload?.tablePageNo
    }else if(payload?.page){
        query+="&page="+payload?.page
    }
    if(payload?.tableRecordLimit){
        query+="&size="+payload?.tableRecordLimit
    }else if(payload?.size){
        query+="&size="+payload?.size
    }
    if(payload?.searchQuery !== undefined){
        query+="&search="+payload?.searchQuery
    }else if(payload?.search !== undefined){
        query+="&search="+payload?.search
    }

    if (payload?.itemIds?.length > 0) {
        query += `&itemIds=${(payload?.itemIds || [])?.join(",")}`;
    } else if (payload?.categoryIds?.length > 0) {
        query += `&categoryIds=${(payload?.categoryIds || [])?.join(",")}`;
    }else if(payload?.groupByCategory){
        query+=`&groupByCategory=${payload?.groupByCategory}`
    }
    if(payload?.reason){
        query+=`&reason=${payload?.reason}`
    }
    if(payload?.offer){
        query+=`&offer=${payload?.offer}`
    }
    if(payload?.chartSliceName){
         query+=`&chartSliceName=${payload?.chartSliceName}`
    }

    if(payload?.type){
        query+=`&type=${payload?.type}`
   }

    if (payload?.sortBy !== undefined && payload?.sortBy !== null && payload?.sortBy !== "") {
        query += `&sortBy=${payload?.sortBy}`;
    }

    if (payload?.sortAsc !== undefined && payload?.sortAsc !== null) {
        query += `&sortAsc=${payload?.sortAsc}`;
    }

    return "?"+query?.slice(1)
}

const generateQueryParamsForDownload = (payload) => {
    let query = "";
    if(payload?.locationId){
        query+="&locationId="+payload?.locationId
    }else if(payload?.locationid){
        query+="&locationId="+payload?.locationid
    }

    if(payload?.startDate){
        query+="&startDate="+payload?.startDate
    }
    if(payload?.endDate){
        query+="&endDate="+payload?.endDate
    }

    if (payload?.tablePageNo !== undefined && payload?.tablePageNo !== null) {
        query += "&page=" + payload.tablePageNo;
    } else if (payload?.page !== undefined && payload?.page !== null) {
        query += "&page=" + payload.page;
    }

    if(payload?.tableRecordLimit){
        query+="&size="+payload?.tableRecordLimit
    }else if(payload?.size){
        query+="&size="+payload?.size
    }

    // if(payload?.searchQuery && payload?.searchQuery !== ""){
    //     query+="&search="+payload?.searchQuery
    // }else if(payload?.search && payload?.search !==""){
    //     query+="&search="+payload?.search
    // }

    if(payload?.searchQuery){
        query+="&search="+payload?.searchQuery
    }else if(payload?.search|| payload?.search===""){
        query+="&search="+payload?.search
    }

    if (payload?.itemIds?.length > 0) {
        query += `&itemIds=${(payload?.itemIds || [])?.join(",")}`;
    } else if (payload?.categoryIds?.length > 0) {
        query += `&categoryIds=${(payload?.categoryIds || [])?.join(",")}`;
    }else if(payload?.groupByCategory){
        query+=`&groupByCategory=${payload?.groupByCategory}`
    }
    if(payload?.reason){
        query+=`&reason=${payload?.reason}`
    }
    if(payload?.offer){
        query+=`&offer=${payload?.offer}`
    }
    if(payload?.chartSliceName){
         query+=`&chartSliceName=${payload?.chartSliceName}`
    }

    if(payload?.type !== undefined && payload?.type !== null){
        query+=`&type=${payload?.type}`
   }

    if (payload?.sortBy !== undefined && payload?.sortBy !== null && payload?.sortBy !== "") {
        query += `&sortBy=${payload?.sortBy}`;
    }

    if (payload?.sortAsc !== undefined && payload?.sortAsc !== null) {
        query += `&sortAsc=${payload?.sortAsc}`;
    }

    return "?"+query?.slice(1)
}

export const getPaidCancelledOrders = (paidCancelledOrdersPayload) => {
    const query=generateQueryParams(paidCancelledOrdersPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/live/canceledOrders${query}`,
    });
};

export const getSalesSummary = (getSalesLocationStartEndDate) => {
    const query=generateQueryParams(getSalesLocationStartEndDate)
    return REPORTS_API({
        method: "get",
        url: `/sales/summary${query}`,
    });
};

export const getSalesByItemCategory = (salesByItemCategoryPayload) => {
    const query=generateQueryParams(salesByItemCategoryPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/category${query}`,
    });
}

export const getSalesByRevenueClass = (salesByRevenueClassPayload) => {
    const query=generateQueryParams(salesByRevenueClassPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/tags${query}`,
    });
}

export const getActualSales = (actualSalesPayload) => {
    const query=generateQueryParams(actualSalesPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/payment${query}`,
    });
}

export const getTenderTypes = (actualSalesPayload) => {
    const query=generateQueryParams(actualSalesPayload,)
    return REPORTS_API({
        method: "get",
        url: `/sales/live/payment${query}`,
    });
}


export const getHourlySalesChart = (hourlySalesPayload) => {
    const query=generateQueryParams(hourlySalesPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/hourly${query}`,
    });
}


export const getLiveDiscount = (liveDiscountPayload) => {

    return REPORTS_API({
        method: "get",
        url: `${LIVE_DISCOUNT_ENDPOINT}locationId=${liveDiscountPayload?.locationid}`,
    });
}

export const getLiveOpenSales = (liveOpenSalesPayload) => {
    return REPORTS_API({
        method: "get",
        url: `${LIVE_OPEN_SALES_ENDPOINT}locationId=${liveOpenSalesPayload?.locationid}`,
    });
}


export const getLiveOrders = (liveOrdersPayload) => {
    const query = generateQueryParams(liveOrdersPayload);

    // /sales/overallOrders${query}

    // const {
    //   locationid,
    //   tablePageNo,
    //   tableRecordLimit,
    //   searchQuery,
    //   type, // this may or may not exist
    //   sortBy, // this may or may not exist
    //   sortAsc, // this may or may not exist
    // } = liveOrdersPayload;

    // const baseURL = `${LIVE_ORDERS_ENDPOINT}locationId=${locationid}&page=${tablePageNo}&size=${tableRecordLimit}&search=${searchQuery || ""}`;
    // const typeParam = type ? `&type=${type}` : "";
    // const sortByParam = sortBy ? `&sortBy=${sortBy}` : "";
    // const sortAscParam = sortAsc ? `&sortAsc=${sortAsc}` : "";

    return REPORTS_API({
      method: "get",
      url: `/sales/live/tables${query}`,
    });
  };

export const getLiveRefunds = (liveRefundsPayload) => {
    return REPORTS_API({
        method: "get",
        url: `${LIVE_REFUNDS_ENDPOINT}locationId=${liveRefundsPayload?.locationid}`,
    });
}

export const getLiveNetSales = (liveNetSalesPayload) => {
    return REPORTS_API({
        method: "get",
        url: `${LIVE_NET_SALES_ENDPOINT}locationId=${liveNetSalesPayload?.locationid}`,
    });
}

export const getLiveOrderNonDineIn = (liveOrderNonDineInPayload) => {
    const query = generateQueryParams(liveOrderNonDineInPayload);
    // &search=${liveOrderNonDineInPayload?.searchQuery || ""}
    // const {
    //     locationid,
    //     tablePageNo,
    //     tableRecordLimit,
    //     searchQuery,
    //     type, // this may or may not exist
    //     sortBy, // this may or may not exist
    //     sortAsc, // this may or may not exist
    //   } = liveOrderNonDineInPayload;
    //   const baseURL = `${LIVE_ORDER_NON_DINE_IN_ENDPOINT}locationId=${locationid}&page=${tablePageNo}&size=${tableRecordLimit}&search=${searchQuery || ""}`;
    //   const typeParam = type ? `&type=${type}` : "";
    //   const sortByParam = sortBy ? `&sortBy=${sortBy}` : "";
    //   const sortAscParam = sortAsc ? `&sortAsc=${sortAsc}` : "";
    return REPORTS_API({
        method: "get",
        url: `/sales/live/tracking${query}`,
    });
}

export const getOrderTracker = (liveOrderNonDineInPayload) => {
    // &search=${liveOrderNonDineInPayload?.searchQuery || ""}
    const {
        locationid,
        tablePageNo,
        tableRecordLimit,
        searchQuery,
        type, // this may or may not exist
      } = liveOrderNonDineInPayload;
      const baseURL = `${TRACKER_ENDPOINT}locationId=${locationid}&page=${tablePageNo}&size=${tableRecordLimit}&search=${searchQuery || ""}`;
      const typeParam = type ? `&type=${type}` : "";
    return REPORTS_API({
        method: "get",
        url: `${baseURL}${typeParam}`,
    });
}

export const getOverallOrderNonDineIn = (liveOrderNonDineInPayload) => {
    // &search=${liveOrderNonDineInPayload?.searchQuery || ""}
    const {
        locationid,
        tablePageNo,
        tableRecordLimit,
        searchQuery,
        type, // this may or may not exist
      } = liveOrderNonDineInPayload;
      const baseURL = `${OVERALL_ORDER_NON_DINE_IN_ENDPOINT}locationId=${locationid}&page=${tablePageNo}&size=${tableRecordLimit}&search=${searchQuery || ""}`;
      const typeParam = type ? `&type=${type}` : "";
    return REPORTS_API({
        method: "get",
        url: `${baseURL}${typeParam}`,
    });
}
export const getDiscountSummary = (discountSummaryPayload) => {
    const query = generateQueryParams(discountSummaryPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/discountSummary${query}`,
    });
}

export const getCancellationSummary = (cancellationSummaryPayload) => {
    const query = generateQueryParams(cancellationSummaryPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/cancelSummary${query}`,
    });
}

export const getEmployeeStaffTipGratuity = (employeeStaffTipGratuityPayload) => {
    return REPORTS_API({
        method: "get",
        url: `${EMPLOYEE_STAFF_TIP_GRATUITY_ENDPOINT}locationId=${employeeStaffTipGratuityPayload?.locationid}&startDate=${employeeStaffTipGratuityPayload?.startDate}&endDate=${employeeStaffTipGratuityPayload?.endDate}&page=${employeeStaffTipGratuityPayload?.tablePageNo}&size=${employeeStaffTipGratuityPayload?.tableRecordLimit}`,
    });
}

export const getEmployeeStaffDiscount = (employeeStaffDiscountPayload) => {
    return REPORTS_API({
        method: "get",
        url: `${EMPLOYEE_STAFF_DISCOUNT_ENDPOINT}locationId=${employeeStaffDiscountPayload?.locationid}&startDate=${employeeStaffDiscountPayload?.startDate}&endDate=${employeeStaffDiscountPayload?.endDate}&page=${employeeStaffDiscountPayload?.tablePageNo}&size=${employeeStaffDiscountPayload?.tableRecordLimit}`,
    });
}

export const getEmployeeStaffPerformance = (employeeStaffPerformancePayload) => {
    return REPORTS_API({
        method: "get",
        url: `${EMPLOYEE_STAFF_PERFORMANCE_ENDPOINT}locationId=${employeeStaffPerformancePayload?.locationid}&startDate=${employeeStaffPerformancePayload?.startDate}&endDate=${employeeStaffPerformancePayload?.endDate}&page=${employeeStaffPerformancePayload?.tablePageNo}&size=${employeeStaffPerformancePayload?.tableRecordLimit}`,
    });
}

export const getEmployeeStaffActivity = (employeeStaffActivityPayload) => {
    return REPORTS_API({
        method: "get",
        url: `${EMPLOYEE_STAFF_ACTIVITY_ENDPOINT}locationId=${employeeStaffActivityPayload?.locationid}&startDate=${employeeStaffActivityPayload?.startDate}&endDate=${employeeStaffActivityPayload?.endDate}&page=${employeeStaffActivityPayload?.tablePageNo}&size=${employeeStaffActivityPayload?.tableRecordLimit}`,
    });
}


export const getDayCheckIn = (dayCheckInPayload) => {

    return REPORTS_API({
        method: "get",
        url: `/sales/checkIn/dayCheckIn?locationId=${dayCheckInPayload?.locationid}&startDate=${dayCheckInPayload?.startDate}&endDate=${dayCheckInPayload?.endDate}&page=${dayCheckInPayload?.tablePageNo}&size=${dayCheckInPayload?.tableRecordLimit}`,
    });
}

export const getDailyCheckIn = (dailyCheckInPayload) => {
    return REPORTS_API({
        method: "get",
        url: `/sales/checkIn/dailyCheckIn?locationId=${dailyCheckInPayload?.locationid}&startDate=${dailyCheckInPayload?.startDate}&endDate=${dailyCheckInPayload?.endDate}&page=${dailyCheckInPayload?.tablePageNo || null}&size=${dailyCheckInPayload?.tableRecordLimit || null}`,
    });
}

export const getDailyGuest = (dailyGuestPayload) => {
    return REPORTS_API({
        method: "get",
        url: `/sales/checkIn/dailyGuests?locationId=${dailyGuestPayload?.locationid}&startDate=${dailyGuestPayload?.startDate}&endDate=${dailyGuestPayload?.endDate}&page=${dailyGuestPayload?.tablePageNo}&size=${dailyGuestPayload?.tableRecordLimit}`,
    });
}

export const getDailyCancellation = (dailyCancellationPayload) => {
    return REPORTS_API({
        method: "get",
        url: `/sales/checkIn/dailyCancellation?locationId=${dailyCancellationPayload?.locationid}&startDate=${dailyCancellationPayload?.startDate}&endDate=${dailyCancellationPayload?.endDate}&page=${dailyCancellationPayload?.tablePageNo}&size=${dailyCancellationPayload?.tableRecordLimit}`,
    });
}

export const getHourlyGuests = (hourlyGuestsPayload) => {
    return REPORTS_API({
        method: "get",
        url: `/sales/checkIn/hourlyGuests?locationId=${hourlyGuestsPayload?.locationid}&startDate=${hourlyGuestsPayload?.startDate}&endDate=${hourlyGuestsPayload?.endDate}&page=${hourlyGuestsPayload?.tablePageNo || null}&size=${hourlyGuestsPayload?.tableRecordLimit || null}`,
    });
}

export const getDailyHourlyCheckIn = (dailyHouryCheckInPayload) => {
    return REPORTS_API({
        method: "get",
        url: `/sales/checkIn/dailyHourlyCheckin?locationId=${dailyHouryCheckInPayload?.locationid}&startDate=${dailyHouryCheckInPayload?.startDate}&endDate=${dailyHouryCheckInPayload?.endDate}&page=${dailyHouryCheckInPayload?.tablePageNo}&size=${dailyHouryCheckInPayload?.tableRecordLimit}`,
    });
}

export const getDayOverDayGuest = (dayOverDayGuestPayload) => {
    return REPORTS_API({
        method: "get",
        url: `/sales/checkIn/dayOverDayGuest?locationId=${dayOverDayGuestPayload?.locationid}&startDate=${dayOverDayGuestPayload?.startDate}&endDate=${dayOverDayGuestPayload?.endDate}&page=${dayOverDayGuestPayload?.tablePageNo}&size=${dayOverDayGuestPayload?.tableRecordLimit}`,
    });
}

export const getPeakSummary = (peakSummaryPayload) => {
    return REPORTS_API({
        method: "get",
        url: `/sales/checkIn/peakSummary?locationId=${peakSummaryPayload?.locationid}&startDate=${peakSummaryPayload?.startDate}&endDate=${peakSummaryPayload?.endDate}&page=${peakSummaryPayload?.tablePageNo}&size=${peakSummaryPayload?.tableRecordLimit}`,
    });
}

export const getPartySize = (partySizePayload) => {
    return REPORTS_API({
        method: "get",
        url: `/sales/checkIn/partySize?locationId=${partySizePayload?.locationid}&startDate=${partySizePayload?.startDate}&endDate=${partySizePayload?.endDate}&page=${partySizePayload?.tablePageNo}&size=${partySizePayload?.tableRecordLimit}`,
    });
}

export const getCustomerSize = (customerSizePayload) => {
    return REPORTS_API({
        method: "get",
        url: `/sales/checkIn/customerSize?locationId=${customerSizePayload?.locationid}&startDate=${customerSizePayload?.startDate}&endDate=${customerSizePayload?.endDate}&page=${customerSizePayload?.tablePageNo}&size=${customerSizePayload?.tableRecordLimit}`,
    });
}

export const getNewCustomerSize = (newCustomerSizePayload) => {
    return REPORTS_API({
        method: "get",
        url: `/sales/checkIn/newCustomerSize?locationId=${newCustomerSizePayload?.locationid}&startDate=${newCustomerSizePayload?.startDate}&endDate=${newCustomerSizePayload?.endDate}&page=${newCustomerSizePayload?.tablePageNo}&size=${newCustomerSizePayload?.tableRecordLimit}`,
    });
}

export const getCustomerDetails = (customerDetailsPayload) => {
    return REPORTS_API({
        method: "get",
        url: `/sales/checkIn/customerDetails?locationId=${customerDetailsPayload?.locationid}&startDate=${customerDetailsPayload?.startDate}&endDate=${customerDetailsPayload?.endDate}&page=${customerDetailsPayload?.tablePageNo}&size=${customerDetailsPayload?.tableRecordLimit}`,
    });
}

export const getLiveCheckInStatus = (liveCheckInStatusPayload) => {
    return REPORTS_API({
        method: "get",
        url: `/sales/checkIn/liveCheckInStatus?locationId=${liveCheckInStatusPayload?.locationid}&startDate=${liveCheckInStatusPayload?.startDate}&endDate=${liveCheckInStatusPayload?.endDate}&page=${liveCheckInStatusPayload?.tablePageNo}&size=${liveCheckInStatusPayload?.tableRecordLimit}`,
    });
}

export const getDailyCheckInStatus = (dailyCheckInStatusPayload) => {
    const query=generateQueryParams(dailyCheckInStatusPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/checkIn/dailyCheckInStatus${query}`,
    });
}

export const getBilledAndUnbilled = (billedAndUnbilledPayload) => {
    // console.log('inside REPORTS_API')
    return REPORTS_API({
        method: "get",
        url: `/sales/live/billedOrders?locationId=${billedAndUnbilledPayload?.locationid}&type=${billedAndUnbilledPayload?.type}`,
    });
}

export const getBilled = (billedPayload) => {
    // console.log('inside REPORTS_API')
    return REPORTS_API({
        method: "get",
        url: `/sales/live/billedOrders?locationId=${billedPayload?.locationid}&type=${billedPayload?.type}`,
    });
}

export const getUnbilled = (unBilledPayload) => {
    // console.log('inside REPORTS_API')
    return REPORTS_API({
        method: "get",
        url: `/sales/live/billedOrders?locationId=${unBilledPayload?.locationid}&type=${unBilledPayload?.type}`,
    });
}



export const getEmployeeSalesOverview = (employeeSalesOverviewPayload) => {
    const { locationid, startDate, endDate, staffId } = employeeSalesOverviewPayload || {};

    let url = `/sales/employee/overview?locationId=${locationid}&startDate=${startDate}&endDate=${endDate}`;

    if (staffId && staffId !== "all") {
        url += `&staffId=${staffId}`;
    }

    return REPORTS_API({
        method: "get",
        url,
    });
};


export const getVoidedSummary = (voidedSummaryPayload) => {
const query=  generateQueryParams(voidedSummaryPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/category/getVoidedDetailsSummary${query}`,
    });
}


export const getDropDownDetails = (dropDownDetailsPayload) => {
    const query=  generateQueryParams(dropDownDetailsPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/category/getDropDownDetails${query}`,
    });
}

export const getCategoryChannelSummary = (categoryChannelSummaryPayload) => {
const query=  generateQueryParams(categoryChannelSummaryPayload)

    let url = `/sales/category/getCategoryChannelSummary${query}`;



    return REPORTS_API({
        method: "get",
        url: url,
    });
}


export const getSalesSummaryReport = (salesSummaryReportPayload) => {
const query=  generateQueryParams(salesSummaryReportPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/summary${query}`,
    });
}


export const getCategorySalesSummary = (categorySalesSummaryPayload) => {
const query=  generateQueryParams(categorySalesSummaryPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/category/getCategorySalesSummary${query}`,
    });
}

export const getSalesByChannel = (salesByChannelPayload) => {
    const query=  generateQueryParams(salesByChannelPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/channel${query}`,
    });
}


export const getCategorySales = (categorySalesPayload) => {
    const query = generateQueryParams(categorySalesPayload)

    return REPORTS_API({
        method: "get",
        url: `/sales/category/getCategorySales${query}`,
    });
}
export const getOfferSummary = (offerSummaryPayload) => {
    const query = generateQueryParams(offerSummaryPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/offerSummary${query}`,
    });
}

export const getVoidedOrderSummary = (voidedSummaryPayload) => {
    const query = generateQueryParams(voidedSummaryPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/voidedSummary${query}`,
    });
}

export const getStaffSales = (staffSalesPayload) => {
    const query = generateQueryParams(staffSalesPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/staff${query}`,

    });
}

export const getPaymentDetails = (paymentDetailsPayload) => {
    const query = generateQueryParams(paymentDetailsPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/payment${query}`,
    });
}

export const getSalesCategory = (salesCategoryPayload) => {
    const query = generateQueryParams(salesCategoryPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/category${query}`,
    });
}

export const getSalesCardType = (salesCardTypePayload) => {
    const query = generateQueryParams(salesCardTypePayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/cardType${query}`,
    });
}
export const getLocationDetails = (LocationDetailsPayload) => {
    return REPORTS_API({
        method: "get",
        url: `/sales/location?locationId=${LocationDetailsPayload?.locationId}`,
    });
}
export const getHourlySalesReportChart = (hourlySalesPayload) => {
    const query = generateQueryParams(hourlySalesPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/hourly?${query}`,
    });
}


export const getEmployeeActivity = (employeeActivityPayload) => {
    const { locationid, startDate, endDate, staffId } = employeeActivityPayload || {};

    let url = `/sales/employee/activity?locationId=${locationid}&startDate=${startDate}&endDate=${endDate}`;

    if (staffId && staffId !== "all" && staffId !== "All") {
        url += `&staffId=${staffId}`;
    }

    return REPORTS_API({
        method: "get",
        url,
    });
};

export const getPremisesSummary = (premisesSummaryPayload) => {
    const query=generateQueryParams(premisesSummaryPayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/premisesSummary${query}`,
    });
}

// https://rptd.gcp.magilhub.com/magilhub-data-services-reports/sales/employee/activity/actions?locationId=d15139f6-ea2b-4b4c-8541-7a9112bfd8bf&startDate=2024-11-01&endDate=2024-12-31&action=Void payment,Remove Tax

export const getEmployeeChartSliceTable = (employeeChartSliceTablePayload) => {
    const query=generateQueryParams(employeeChartSliceTablePayload)
    return REPORTS_API({
        method: "get",
        url: `/sales/employee/activity/actions${query}`,
    });
}



export const getDownloadableReport = (payload) => {
    const {apiEndPoint, ...queryParams}=payload
    const query=generateQueryParamsForDownload(queryParams)

    return REPORTS_API({
        method: "get",
        url: `${apiEndPoint}${query}`,
    });
}

export const getOrdersInfo = (payload) => {
    const query=generateQueryParams(payload)
    return REPORTS_API({
        method: "get",
        url: `/sales/overallOrders${query}`,
    });
}

export const getVoidedOrdersSales = (payload) => {
    const query=generateQueryParams(payload)
    return REPORTS_API({
        method: "get",
        url: `/sales/voided-order-pie-chart${query}`,
    });
}


export const getComplementary = (payload) => {
    const query=generateQueryParams(payload)
    return REPORTS_API({
        method: "get",
        url: `/sales/complementary-order-pie-chart${query}`,
    });
}

export const getVoidedOrderTable = (payload) => {
    const query=generateQueryParams(payload)
    return REPORTS_API({
        method: "get",
        url: `/sales/void-and-comp-summary${query}`,
    });
}

export const getComplementaryTable = (payload) => {
    const query=generateQueryParams(payload)
    return REPORTS_API({
        method: "get",
        url: `/sales/void-and-comp-summary${query}`,
    });
}

export const getUnpaidVoidedOrders = (payload) => {
    const query=generateQueryParams(payload)
    return REPORTS_API({
        method: "get",
        url: `/sales/live/unpaid-void-orders${query}`,
    });
}

export const getUnpaidComplementaryOrders = (payload) => {
    const query=generateQueryParams(payload)
    return REPORTS_API({
        method: "get",
        url: `/sales/live/unpaid-comp-orders${query}`,
    });
}

export const getPaidVoidedOrders = (payload) => {
    const query=generateQueryParams(payload)
    return REPORTS_API({
        method: "get",
        url: `/sales/live/paid-void-orders${query}`,
    });
}
